export const ACTION_TYPES = {
  CLEAR_ERROR: "CLEAR_ERROR",
  TRIGGER_ERROR: "TRIGGER_ERROR",
  UPDATE_CONTACT_LIST: "UPDATE_CONTACT_LIST",
  UPDATE_CONTACT_NAMES: "UPDATE_CONTACT_NAMES",
  UPDATE_CUR_CONTACT: "UPDATE_CUR_CONTACT",
  UPDATE_CUR_NOTIF_DETAILS: "UPDATE_CUR_NOTIF_DETAILS",
  UPDATE_CUR_STANDBY_INSPECTOR: "UPDATE_CUR_STANDBY_INSPECTOR",
  UPDATE_NOTIF_INTERNAL: "UPDATE_NOTIF_INTERNAL",
  UPDATE_NOTIF_LIST: "UPDATE_NOTIF_LIST",
  UPDATE_PERMISSIONS: "UPDATE_PERMISSIONS",
  UPDATE_REG_CODES_LIST: "UPDATE_REG_CODES_LIST",
  UPDATE_STANDBY_INSPECTORS_LIST: "UPDATE_STANDBY_INSPECTORS_LIST",
};
